module.exports = __webpack_public_path__ + "r-v3/img/stopwatch_pause_white.6ea67810.svg";